import ImageBackgroundComponent from "./image-background.component";

export default ImageBackgroundComponent;
